<template>
  <div class="w100 Contenido">
    <Titulo seccion="Análisis Químico y Físico de Suelo" icon="flask"/>
    <Descripcion>A través de análisis georreferenciados se analizan las propiedades químicas y físicas del suelo.</Descripcion>
    <Tabla nombre="Suelos" :columnas="columnasTabla"/>
  </div>
</template>

<script>
import { ColumnasTabla } from "../../Auxiliares/Enums";

export default {
  name: "Suelos",
  data() {
    return {
      columnasTabla: [ ColumnasTabla.Productor, ColumnasTabla.Establecimiento, ColumnasTabla.Localidad ]
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../Css/Componentes.scss";
@import "../../Css/Globales.css";
@import "../../Css/Secciones/Tabla.css";
</style>
